<div #container>
  <app-badge variant="red" class="cursor-pointer" title="Supplier Details">
    <span class="grid grid-cols-[auto_auto] gap-1 justify-items-center">
      <span>{{ data().total }}</span>
      <app-icons icon="truck" svgClass=""/>
    </span>
  </app-badge>

  <app-tooltip [triggerEl]="container" triggerType="click" placement="left">
    <div class="text-left overflow-x-auto">
      <h5 class="text-lg font-bold dark:text-white">Supplier Details</h5>
      <table class="dark">
        <thead>
        <tr>
          <th>Location</th>
          <th>Qty</th>
          <th>Delivery</th>
          <th>Cost</th>
          <th>MAP</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
          @for (source of data().sources; track $index) {
            <tr>
              <td class="whitespace-nowrap">
                <span>{{source.vendor.name}} - {{ source.name }}</span>
              </td>
              <td class="text-right">{{ source.quantity }}</td>
              <td>
                {{source.estimated_delivery_date}}

                @if (source.cutoff_date) {
                  <div class="text-xs">
                    Cutoff: {{source.cutoff_date | date: 'shortTime'}}
                  </div>
                }
              </td>
              <td class="text-right">{{ source.cost | currency }}</td>
              <td class="text-right">
                @if (source.map) {
                  {{ source.map | currency }}
                }
              </td>
              <td class="text-right">{{ price()(source.cost) | currency }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </app-tooltip>
</div>
